import { useState } from "react";

/** Re-runs the page's own last data-fetch (with whatever filters/pagination
 * it already has) instead of a full page/browser reload. Every admin page
 * with a data fetch should wire one of these to its existing fetch
 * callback(s) — never introduce a new API call just for this button. */
const RefreshButton: React.FC<{
  onRefresh: () => void | Promise<void>;
  className?: string;
  label?: string;
}> = ({ onRefresh, className = "", label = "Refresh" }) => {
  const [spinning, setSpinning] = useState(false);

  const handleClick = async () => {
    if (spinning) return;
    setSpinning(true);
    try {
      await onRefresh();
    } finally {
      setSpinning(false);
    }
  };

  return (
    <button
      onClick={handleClick}
      disabled={spinning}
      className={`px-4 py-2 bg-gray-800 hover:bg-gray-700 rounded-xl text-sm text-gray-300 shrink-0 disabled:opacity-60 ${className}`}
    >
      {spinning ? "Refreshing…" : label}
    </button>
  );
};

export default RefreshButton;
